module.exports = __webpack_public_path__ + "img/certificate7.e8d7be01.jpg";